import styled, { css } from 'styled-components';
import { Input as AntdInput, InputNumber as AntdInputNumber } from 'antd';
import theme from '../theme';

type MixinProps = {
  $width?: string | number;
  $imposeWrap?: boolean;
  $error?: React.ReactNode;
};

const mixin = css<MixinProps>`
  && {
    border-color: transparent;
    ${({ $imposeWrap }) =>
      $imposeWrap ? `white-space: normal` : `white-space: nowrap;`};
    overflow: hidden;
    text-overflow: ellipsis;
    ${({ $error }) =>
      $error && `border: 1px solid ${theme.getColor('danger')}`};
    ${({ $width = '100%' }) => `
        width: ${$width};
      `}
  }
`;

export const StyledInput = styled(AntdInput)`
  ${mixin}
`;

export const StyledInputNumber = styled(AntdInputNumber)<{
  $hideArrows?: boolean;
  $alwaysShowArrows?: boolean;
  $width?: React.ReactText;
  $error?: React.ReactNode;
}>`
  ${mixin}
  ${({ $hideArrows }) => {
    if ($hideArrows)
      return `.ant-input-number-handler-wrap {
    display: none;
  }`;
  }}
  ${({ $alwaysShowArrows }) => {
    if ($alwaysShowArrows)
      return `.ant-input-number-handler-wrap {
      opacity: 1;
    }`;
  }}
`;

export const StyledInputTextArea = styled(AntdInput.TextArea)`
  ${mixin}
`;

export const StyledAddonAfter = styled.div<{
  $size: 'small' | 'middle' | 'large';
}>`
  position: absolute;
  bottom: 0;
  right: 11px;
  line-height: 2;
  user-select: none;
  ${({ $size }) => {
    if ($size === 'small') return 'height: 22px';
    if ($size === 'middle') return 'height: 30px';
    return 'height: 38px';
  }}
`;
